module.exports = __webpack_public_path__ + "img/1-10.9bc52ef1.png";